import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import cogoToast from "cogo-toast";
import { BACKEND_URL } from "../../../constants";
import Input from "components/Input/Input";
import PublitioAPI from 'publitio_js_sdk'
import ButtonPrimary from "components/Button/ButtonPrimary";
import Heading2 from "components/Heading/Heading2";
import Datetime from 'react-datetime';
import 'moment/locale/pl';
import { 
  BtnBold,
  BtnBulletList,
  BtnClearFormatting,
  BtnItalic,
  EditorProvider,
  Editor,
  BtnLink,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnStyles,
  BtnUnderline,
  BtnUndo,
  HtmlButton,
  Separator,
  Toolbar,
} from 'react-simple-wysiwyg';
import ClipLoader from "react-spinners/ClipLoader";
import "react-datetime/css/react-datetime.css";
import Layout from "../layout";




function ensurePublitioTransform(url, defaultTransform = "h_720") {
  try {
    const parsed = new URL(url);

    // Sprawdzamy czy link jest z Publitio
    if (!parsed.hostname.includes("publit.io")) return url;

    const pathParts = parsed.pathname.split("/").filter(Boolean);
    const fileIndex = pathParts.indexOf("file");

    // Jeżeli po "file" jest transformacja → zostaw
    if (
      fileIndex >= 0 &&
      pathParts[fileIndex + 1] &&
      pathParts[fileIndex + 1].match(/^[a-z]_\d+/)
    ) {
      return url;
    }

    // Dodaj domyślną transformację
    pathParts.splice(fileIndex + 1, 0, defaultTransform);
    parsed.pathname = "/" + pathParts.join("/");

    return parsed.toString();
  } catch (e) {
    console.error("Błędny URL Publitio:", e);
    return url;
  }
}

const PageAddFotos = () => {
  const publitio = new PublitioAPI('m7RBc51bBSJtDLyfn5ox', 'D7e4hWupPLHs0wqpXQDNQy2kJ6vVQZWZ')
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  let user = sessionStorage.getItem("user")
  let userId = JSON.parse(user)?.user.id
  const {
    register,
    getValues,
    // formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      title: "",
      image: "",
    },
  });

  const addPhotos = async (e) => {
    setLoading(true)
    const data = getValues();
    let photo;
    e.preventDefault();
    photo = await publitio.uploadFile(data.image[0], 'file')
    setTimeout(() => {
      fetch(`${BACKEND_URL}/add-fotos`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          title: data.title,
          image: photo.url_preview ? photo.url_preview : null,
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.statusCode === 200) {
            setLoading(false)
            cogoToast.success("Zdjęcie zostało dodane");
            window.location.reload()
          }
          else if(response.statusCode === 400) {
            cogoToast.error("Wystąpił jakiś błąd");
          } 
        })
        .catch((error) => console.error("error: ", error));
    }, [2000]);
  };
  return (
    <Layout>
      <header className="text-center max-w-2xl mx-auto - mb-14 sm:mb-16 lg:mb-20 ">
        <Heading2>Dodaj Zdjęcie</Heading2>
        {/* <span className="block text-sm mt-2 text-neutral-700 sm:text-base dark:text-neutral-200">
         Witamy
        </span> */}
      </header>

      <div className="max-w-md mx-auto space-y-6">
        {/* FORM */}
        <form className="grid grid-cols-1 gap-6" action="#" method="post">
          <label className="block">
            <Input
             {...register("title", {
              required: { value: true, message: "Pole wymagane" },
            })}
              type="text"
              placeholder="Dodaj tytuł zdjęcia"
              className="mt-1"
            />
          </label>
          <label className="block">Dodaj zdjęcie
            <Input {...register("image", {
            })} type="file" max-size="200000" className="mt-1" />
          </label>
        </form>
        <p>Chwilowo prosze usuwać lub zamieniać wszystkie pojedyncze apostrofy na podwójne w tekście artykułu</p>
        <ButtonPrimary onClick={addPhotos}>Dodaj</ButtonPrimary>
        {/* {user.user.type == "admin" && <button onClick={getArticles}>Automatyzacja artykułów</button>} */}
        {loading == true && 
        <div style={{marginTop:'40px'}}>
          <p style={{marginBottom:'20px'}}>Uwaga dodawanie tytułu zdjęcia może chwile potrwać zależności od wielkości wysłanej grafiki.</p>
          <ClipLoader color="black" size={50} aria-label="Loading Spinner" data-testid="loader"/>
          </div>}
      </div>
    </Layout>
  );
};

export default PageAddFotos;